import { TechFeature } from '../types/tech.types';

export const TECH_FEATURES: TechFeature[] = [
  {
    id: 'hpb',
    name: 'Batería HPB',
    title: 'High Performance Battery',
    description: 'Nuestra tecnología propietaria de celdas de alta densidad energética. Maximiza la autonomía y la vida útil.',
    benefits: [
      { title: '+25% Rendimiento', description: 'Comparado con baterías estándar' },
      { title: 'Fiabilidad y rendimiento', description: 'Mayor durabilidad y eficiencia' },
      { title: 'Control Térmico Inteligente', description: 'Sistema BMS inteligente' }
    ],
    image: '/images/tech-hpb.jpg',
    detailAnchor: 'hpb'
  },
  {
    id: 'aer',
    name: 'Sistema AER',
    title: 'Automatic Energy Recovery',
    description: 'Convierte la energía cinética del frenado en electricidad, recargando la batería mientras conduces.',
    benefits: [
      { title: 'Recarga en marcha', description: 'Al frenar o bajar pendientes' },
      { title: 'Mayor Autonomía', description: 'Extiende tu viaje' }
    ],
    image: '/images/tech-aer.jpg',
    detailAnchor: 'aer'
  },
  {
    id: 'app',
    name: 'Nueva App',
    title: 'Control Total desde tu Smartphone',
    description: 'Integración con Tuya Smartlife. Gestiona tu patinete desde tu smartphone con total facilidad. Disponible para iOS y Android.',
    benefits: [
      { title: 'Bloqueo Remoto', description: 'Seguridad antirrobo desde tu móvil' },
      { title: 'Geolocalización', description: 'Encuentra tu patinete siempre' },
      { title: 'Estadísticas de Viaje', description: 'Historial de rutas y consumo' },
      { title: 'Configuración Avanzada', description: 'Velocidad, Zero Start, Cruise Control' },
      { title: 'Control de Iluminación', description: 'Personaliza tus luces remotamente' },
      { title: 'Integración Domótica', description: 'Conecta con tu hogar inteligente' },
      { title: 'Notificaciones Inteligentes', description: 'Batería baja, mantenimiento, actualizaciones OTA' }
    ],
    image: '/images/tech-app.jpg',
    detailAnchor: 'app'
  },
  {
    id: 'nfc',
    name: 'Unlock&Go',
    title: 'Tecnología NFC',
    description: 'Olvídate de las llaves. Desbloquea tu ZWheel acercando tu tarjeta NFC o tu móvil.',
    benefits: [
      { title: 'Acceso Instantáneo', description: 'Desbloqueo y bloqueo al instante' },
      { title: 'Multi-Tarjeta', description: 'Soporte para múltiples tarjetas NFC' },
      { title: 'Protección Antirrobo', description: 'Máxima seguridad' }
    ],
    image: '/images/tech-nfc.jpg',
    detailAnchor: 'nfc'
  }
];
